import { EmptyButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/EmptyButtonGroup'
import { MedicalReleaseDetailsButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseDetailsButtonGroup'
import { MedicalReleaseDetailsPrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseDetailsPrompt'
import { MedicalReleaseSignatureButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseSignatureButtonGroup'
import { MedicalReleaseSignaturePrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/MedicalReleaseSignaturePrompt'
import { PatientRegistryEnrollmentButtonGroup } from '@components/app/ApplySuccessPage/PostApplyPrompt/PatientRegistryEnrollmentButtonGroup'
import { PatientRegistryEnrollmentPrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/PatientRegistryEnrollmentPrompt'
import { PatientRegistryGuardianPrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/PatientRegistryGuardianPrompt'
import ShareYourStoryButtonGroup from '@components/app/ApplySuccessPage/PostApplyPrompt/ShareYourStoryButtonGroup'
import { ShareYourStoryPrompt } from '@components/app/ApplySuccessPage/PostApplyPrompt/ShareYourStoryPrompt'
import WhyApplyToTrialButtonGroup from '@components/app/ApplySuccessPage/PostApplyPrompt/WhyApplyToTrialButtonGroup'
import WhyApplyToTrialPrompt from '@components/app/ApplySuccessPage/PostApplyPrompt/WhyApplyToTrialPrompt'
import type { ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { AvailabilityButtonGroup } from './AvailabilityButtonGroup'
import { AvailabilitySelectorQuestion } from './AvailabilitySelectorQuestion'
import { PatientCallToSiteStep } from './PatientCallToSiteStep'
import { PatientNavigatorPhoneCallStep } from './PatientNavigatorPhoneCallStep.client'
import SaveStudyTeamContactButtonGroup from './SaveStudyTeamContactButtonGroup'
import SaveStudyTeamContactStep from './SaveStudyTeamContactStep'
import type { PostApplyStep } from './stepTypes'
import { WarmTransferStep } from './WarmTransferStep.client'

export type PostApplyFlowStep = {
  buttonGroup: (props: ApplySuccessPageProps) => JSX.Element
  hideBurger?: boolean
  hideFooter?: boolean
  questionText?: string
  stepContent: (props: ApplySuccessPageProps) => JSX.Element | null
  stepId: PostApplyStep
}

export const PostApplyFlowSteps: PostApplyFlowStep[] = [
  {
    buttonGroup: MedicalReleaseDetailsButtonGroup,
    questionText: "Next, let's request medical records on your behalf",
    stepContent: MedicalReleaseDetailsPrompt,
    stepId: 'medical-release-consent',
  },
  {
    buttonGroup: MedicalReleaseSignatureButtonGroup,
    questionText: 'Complete Your Medical Record Release',
    stepContent: MedicalReleaseSignaturePrompt,
    stepId: 'medical-release-signature',
  },
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'Connect with the Clinical Trial Coordinator',
    stepContent: WarmTransferStep,
    stepId: 'warm-transfer',
  },
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'Connect with the Clinical Trial Coordinator',
    stepContent: PatientCallToSiteStep,
    stepId: 'patient-call-to-site',
  },
  {
    buttonGroup: WhyApplyToTrialButtonGroup,
    questionText: 'Why did you apply to this trial?',
    stepContent: WhyApplyToTrialPrompt,
    stepId: 'why-apply',
  },
  {
    buttonGroup: SaveStudyTeamContactButtonGroup,
    questionText: 'Save the study team to your contacts',
    stepContent: SaveStudyTeamContactStep,
    stepId: 'save-study-team-contact',
  },
  {
    buttonGroup: AvailabilityButtonGroup,
    questionText: 'What time would work for a screening appointment next week?',
    stepContent: AvailabilitySelectorQuestion,
    stepId: 'screening-visit-availability',
  },
  {
    buttonGroup: EmptyButtonGroup,
    hideBurger: true,
    hideFooter: true,
    questionText: 'Confirm details to a few of your responses',
    stepContent: PatientNavigatorPhoneCallStep,
    stepId: 'patient-navigator-agent',
  },
  {
    buttonGroup: ShareYourStoryButtonGroup,
    questionText: 'Be a Hero, Share Your Story',
    stepContent: ShareYourStoryPrompt,
    stepId: 'share-story',
  },
  {
    buttonGroup: PatientRegistryEnrollmentButtonGroup,
    questionText:
      'Would you like researchers to be able to contact you about other trials?',
    stepContent: PatientRegistryEnrollmentPrompt,
    stepId: 'registry',
  },
  {
    buttonGroup: EmptyButtonGroup,
    questionText:
      'Are you registering for yourself, or for someone else as their guardian?',
    stepContent: PatientRegistryGuardianPrompt,
    stepId: 'guardian',
  },
]
